import styled from "styled-components";
import { Grid } from "@mui/material";
import { Divider } from "@mui/material";
import MyTypography from "../Typography";
import MobileIcon from "../../assets/ic-mobilePlanCard.svg";
import DeleteIcon from "../../assets/ic-delete.svg";
import ItemTable from "./ItemTable";
import PlanDetail from "../../pageComponents/shoppingcart/PlanDetail";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ResponsiveUI, WindowSize } from "../../utils/responsive";
import { GetWord, formatCurrency, getItemColumnWidth } from "../../utils/common";
import _ from "lodash";
import CardBase from "../Card/CardBase";

const SpecialFeeContent = ({
  sectionTitle = "Default Title",
  type = "delivery",
  icon,
  renderDetail,
  orderRecord,
  onEdit,
  onDelete,
  remarkProps,
  iconNeedDotDecoration,
  data,
  idx,
  cardBaseStyle = null,
  extraWidthForButton = false,
  useHtml = true,
}) => {
  const { t } = useTranslation("orderContentItem");
  const [showDetail, setShowDetail] = useState(true);
  const windowSize = WindowSize();


  return (
    <CardBase style={{ ...cardBaseStyle }}>
      <ItemTable
        // type={"plan"}
        itemId={data?.itemId}
        colWidth={getItemColumnWidth(type)}
        header={[
          sectionTitle,
          type === "discount" ? t("promoDetails") : "",
          t("price"),
        ]}
        row={[
          GetWord(data?.itemName),
          type === "discount" && data?.description ? GetWord(data?.description) : "",
          data?.subtotal < 0
            ? `-HK$ ${formatCurrency(Math.abs(data?.subtotal), 1)}`
            : `HK$ ${formatCurrency(data?.subtotal, 1)}`,
        ]}
        icon={icon}
        onEdit={onEdit}
        onDelete={onDelete}
        setShowDetail={setShowDetail}
        showDetail={showDetail}
        renderDetail={renderDetail}
        orderRecord={orderRecord}
        iconNeedDotDecoration={iconNeedDotDecoration}
        extraWidthForButton={extraWidthForButton}
        useHtml={useHtml}
      />
      {showDetail && renderDetail}
      {onDelete && (
        <ResponsiveUI
          mobile={
            <>
              <div style={{ display: "flex" }}>
                <Divider style={{ width: "100%" }} />
              </div>
              <DeleteButton onClick={() => onDelete && onDelete()}>
                <img src={DeleteIcon} style={{ marginRight: 5 }} />
                <MyTypography fontSize="18" bold>
                  {t("delete", { ns: "common" })}
                </MyTypography>
              </DeleteButton>
            </>
          }
          desktop={<div />}
        />
      )}
      {remarkProps !== undefined && remarkProps}
    </CardBase>
  );
};

const Card = styled.div`
  background-color: #fff;
  box-shadow: 0 3px 8px 0 #9b9b9b;
  border-radius: 5px;
  margin-bottom: 30px;

  overflow: hidden;
  padding: 20px 30px;
`;

const DeleteButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 25px 0;
`;

export default SpecialFeeContent;
